export default __webpack_public_path__ + "static/media/gray-blob.58721b07.svg";